var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6.85714,
    fill: "#27D045"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6.85714,
    fill: "url(#paint0_linear_9016_40960)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29932 19.4531C14.7044 16.2371 19.634 14.1003 22.1094 13.0635C29.1548 10.1227 30.6358 9.61491 31.5879 9.59375C31.7995 9.59375 32.2649 9.63606 32.5823 9.88995C32.8362 10.1015 32.8997 10.3766 32.942 10.5881C32.9843 10.7997 33.0266 11.244 32.9843 11.5825C32.6035 15.6024 30.9532 25.3559 30.1069 29.8413C29.7472 31.7454 29.049 32.3802 28.372 32.4436C26.891 32.5706 25.7696 31.4704 24.3521 30.5395C22.1094 29.0796 20.8612 28.1699 18.682 26.7312C16.1642 25.0809 17.7933 24.1711 19.232 22.6901C19.6129 22.3093 26.1082 16.3852 26.2351 15.8563C26.2563 15.7928 26.2563 15.539 26.1082 15.412C25.9601 15.2851 25.7485 15.3274 25.5792 15.3697C25.3465 15.412 21.7921 17.7816 14.8736 22.4574C13.8581 23.1556 12.9483 23.4941 12.1232 23.4729C11.2134 23.4518 9.47852 22.9652 8.16677 22.542C6.57997 22.0342 5.31053 21.7592 5.41632 20.8706C5.47979 20.4051 6.11451 19.9397 7.29932 19.4531Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9016_40960",
    x1: 19.9833,
    y1: 0,
    x2: 19.9833,
    y2: 39.6836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e022e4f71eff7a4620e6381aa63571d7.svg";
export { ForwardRef as ReactComponent };